<template>
  <div>
    <div v-loading.fullscreen.lock="loading"></div>
    <div class="OrderDetails">
      <!-- 订单卡片 -->
      <order-car class="ordercar" @alginGet="alginGet" :rowOrder="rowOrder" />

      <!-- 投保地块信息 -->
      <div class="toubaoMessage">
        <!-- 表格  -->
        <table-list-no
          class="tablelist"
          :rowInfoList="rowInfoList"
          :loading="loading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OrderCar from "./compoments/OrderCar.vue";
import TableListNo from "./compoments/TableListNo.vue";
import sameIn from "@/mixins/ruralListsdetails.js";

import { ruralInsurance } from "@/api/request/snkd.produce";
export default {
  name: "OrderDetails",
  mixins: [sameIn],
  components: {
    OrderCar,
    TableListNo,
  },
  data() {
    return {
      loading: true,
      title: "订单详情",
      // 卡片数据
      rowOrder: {},
      // 投保地块信息列表
      rowInfoList: [],
      pageLoading1: false,
    };
  },

  created() {
    this.getLandDetails();
    this.getDetails();
  },

  methods: {
    // 获取保单详情
    async getDetails() {
      this.loading = true;
      const res = await ruralInsurance.getInsurePolicyGet({
        id: this.$route.query.id,
      });
      if (res.respCode === 0) {
        this.rowOrder = res.obj;
        this.loading = false;
      }
    },
    // 获取保单地块详情
    async getLandDetails() {
      this.pageLoading1 = true;
      const res = await ruralInsurance.getInsurePolicyLand({
        id: this.$route.query.id,
      });
      if (res.respCode === 0) {
        this.rowInfoList = res.obj;
        this.pageLoading1 = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.OrderDetails {
  background-color: #fff;
  box-sizing: border-box;
}

.ordercar {
  padding-top: 30px;
}

.tablelist {
  padding: 50px 30px 50px;
}

.listWrapper {
  position: relative;
  height: 100%;
}

.tbody {
  position: relative;
  height: 100%;

  .box {
    padding: 40px 100px;
    .messageUser {
      display: flex;
      font-size: 16px;
      color: #333;
      line-height: 56px;

      .title {
        width: 150px;
        padding-left: 150px;
      }
    }
  }
}

::v-deep .el-table {
  border: 0;
  th,
  tr,
  td {
    border: 0;
  }
  &::before {
    height: 0px;
  }
}
::v-deep .el-dialog__body {
  height: calc(100% - 54px);
  box-sizing: border-box;
  padding: 0;
}
::v-deep .el-dialog__header {
  position: relative;
  z-index: 1;
}

::v-deep .el-dialog {
  height: calc(100% - 160px);
  margin-top: 100px !important;
  overflow: hidden;

  .el-dialog__header {
    background-color: $--color-primary;
    text-align: center;

    .el-dialog__title {
      color: #fff !important;
      font-size: 20px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }
  }
}

// 滚动条样式
::v-deep .bscroll-indicator {
  background-color: #dcdfe6 !important;
}
</style>
